/**
 * Add Observation Actions
 *
 * Actions for managing the add observation form in the NGXS store.
 */

import { Observation } from 'src/app/models/schema';

/**
 * Initialize add observation form
 */
export class InitializeAddObservation {
  static readonly type = '[AddObservation] Initialize';
}

/**
 * Set observation field value
 */
export class SetObservationField {
  static readonly type = '[AddObservation] Set Field';
  constructor(public field: keyof Observation, public value: any) {}
}

/**
 * Update multiple observation fields
 */
export class UpdateObservationFields {
  static readonly type = '[AddObservation] Update Fields';
  constructor(public updates: Partial<Observation>) {}
}

/**
 * Reset add observation form
 */
export class ResetAddObservation {
  static readonly type = '[AddObservation] Reset';
}

/**
 * Set observation data (e.g., when editing)
 */
export class SetObservationData {
  static readonly type = '[AddObservation] Set Data';
  constructor(public observation: Partial<Observation>) {}
}

/**
 * Clear add observation form
 */
export class ClearAddObservation {
  static readonly type = '[AddObservation] Clear';
}
